import React, { useEffect, useState } from 'react'
import AddedStoreBranchCard from '../../../components/AddedStoreBranchCard'
import { api } from '../../../app/Api/ApiSlice'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import Loader from '../../../components/Loader'

const AddedBranches = () => {
    const [branches, setBranches] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const { name } = useParams()

    useEffect(() => {
        const getBranches = async () => {
            try {
                setIsLoading(true)
                const response = await api.get(`/stores/${name}/manage/branches`)
                setIsLoading(false)
                setBranches(response.data.branches)
            } catch (error) {
                toast.error(error.response.data.message)
            }
        }

        getBranches()
    }, [])
    return (
        <div>
            <h2 className='page-header-title'>Branches Added</h2>

            {
                isLoading && <Loader />
            }
            {
                branches.length > 0 && branches.map((b) => (
                    <AddedStoreBranchCard key={b._id} b={b} />
                ))
            }
            {!isLoading && !branches.length && <p className='not-found-msg'>No branches found</p>}
        </div>
    )
}

export default AddedBranches